/* eslint-disable react/display-name */
import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { SelectV2 } from '@smartsheet/lodestar-core';
import React, { useCallback } from 'react';

export interface InputSelectProps extends EntityId {
  value: string;
  options: { label: string; value: string | number }[];
  onChange: (value: string | number) => void;
}

export const InputSelect = React.memo(
  ({ id, onChange, options, value }: InputSelectProps) => {
    const selectedValue =
      options.find(option => value === option.value) || null;

    const onChangeHandler = useCallback(
      newValue => {
        onChange(newValue?.value || '');
      },
      [onChange]
    );

    return (
      (<SelectV2
        id={id}
        locale="en"
        options={options}
        selectedOption={selectedValue}
        getOptionKey={option => option.value as string}
        onChange={onChangeHandler} />)
    );
  }
);
